var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white rounded shadow"},[_c('div',{staticClass:"p-4 flex flex-col items-center"},[_c('p',{staticClass:"text-3xl"},[_vm._v("常见问题")]),_c('div',{staticClass:"py-8",domProps:{"innerHTML":_vm._s(_vm.getCONTENT)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }